const neuron = process.env.REACT_APP_NEX_NEURON_HOST || "innova.tagroot.io";
const protocol = process.env.REACT_APP_NEX_PROTOCOL;
const remoteHttpBackend = protocol + "://" + neuron;
// When the CRA dev server is exposed on a LAN hostname/IP, requests to the
// backend would otherwise be cross-origin. setupProxy.js forwards these
// same-origin requests to the configured remote backend instead.
const useLocalApiProxy = process.env.REACT_APP_USE_LOCAL_API_PROXY === "true";

const BackendConfig = {
  neuronDomain: neuron,
  remoteHttpBackend,
  httpBackend: useLocalApiProxy ? "" : remoteHttpBackend,
  devBackend: process.env.REACT_APP_ENV === "development"
};

export default BackendConfig;
